import '../style.css';
import './style.css';
import { relatedToolsMarkup, siteBrandMarkup } from '../site-chrome';
import { BATTLE_ELEMENTS, CARD_HEIGHT, CARD_STYLES, CARD_THEMES, CARD_WIDTH, DEFAULT_CROP, SAMPLE_PHOTO_URL, makeCardResult, photoValidation, trimCardText, type BattleElement, type CardIdentity, type CardStyle, type CardTheme, type PhotoCrop } from './core';
import { drawCard, type CardDrawing } from './renderer';
import { createPhotoEditor } from './photo-editor';

const app = document.querySelector<HTMLDivElement>('#app');
if (!app) throw new Error('카드 만들기 화면을 찾지 못했습니다.');
document.documentElement.classList.add('my-card-page');

const icons = {
  upload: '<path d="M12 16V4m-4 4 4-4 4 4M5 15v5h14v-5"/>',
  download: '<path d="M12 4v12m-4-4 4 4 4-4M5 16v4h14v-4"/>',
  share: '<path d="M12 16V3m-4 4 4-4 4 4M6 10H4v11h16V10h-2"/>',
  shuffle: '<path d="m17 3 4 4-4 4M3 7h3c5 0 6 10 11 10h4m-4-4 4 4-4 4M3 17h3c2 0 3-2 4-4m4-4c1-1 2-2 3-2h4"/>',
};
const icon = (name: keyof typeof icons) => '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + icons[name] + '</svg>';

app.innerHTML = [
  '<div class="page-shell mc-shell"><div class="blob blob-one" aria-hidden="true"></div><div class="blob blob-two" aria-hidden="true"></div><header class="site-brand-header">' + siteBrandMarkup() + '</header>',
  '<main class="mc-main"><section class="tool-intro mc-intro" aria-labelledby="mc-title"><span class="tool-kicker">오늘의 장난감</span><h1 id="mc-title">나를 카드로 뽑아!</h1><p>사진 한 장으로 나만의 캐릭터 카드를 만들어보세요.</p></section>',
  '<div class="tool-card mc-workspace">',
  '<section class="mc-preview" aria-label="카드 미리보기"><div class="mc-preview-top"><h2>카드 미리보기</h2><span id="mc-sample-tag">샘플 사진</span></div>',
  '<div class="mc-card-stage" id="mc-stage"><div class="mc-card-stack"><canvas id="mc-card" width="900" height="1260" tabindex="-1" role="img" aria-describedby="mc-summary"></canvas>',
  '<div class="mc-card-shine" aria-hidden="true"></div>',
  '<div class="mc-pack" aria-hidden="true"><span class="mc-pack-top">ONEUL / CARD CLUB</span><div class="mc-pack-word">ME<span>!</span></div><span class="mc-pack-caption">세상에 하나뿐인 나</span><div class="mc-pack-seal">SPECIAL EDITION · OPEN YOURSELF</div></div></div>',
  '<button class="mc-skip" type="button" id="mc-skip" hidden>바로 보기 →</button></div>',
  '<div class="mc-preview-caption"><span id="mc-edition">스타 배틀</span><span id="mc-preview-state">사진을 넣어 나만의 카드로</span></div>',
  '<p id="mc-summary" class="mc-sr-only"></p>',
  '<div class="mc-result-actions"><button type="button" class="button button-soft mc-save" id="mc-save" disabled>' + icon('download') + '이미지 저장</button><button type="button" class="button mc-share" id="mc-share" disabled>' + icon('share') + '공유</button></div>',
  '<p class="mc-export-hint">저장한 카드를 스토리나 프로필에 올려보세요.</p></section>',
  '<section class="mc-editor" aria-label="카드 꾸미기"><form id="mc-form"><fieldset><legend>카드 스타일</legend><div class="mc-templates">',
  ...CARD_STYLES.map((style) => '<button class="mc-template" type="button" data-style="' + style.id + '" aria-pressed="' + (style.id === 'battle') + '"><span class="mc-template-image"><canvas width="180" height="252" data-thumb="' + style.id + '" aria-hidden="true"></canvas><span class="mc-template-check" aria-hidden="true">✓</span></span><strong>' + style.title + '</strong></button>'),
  '</div><p class="mc-style-note" id="mc-style-note">빛나는 나의 등장</p></fieldset>',
  '<fieldset class="mc-photo-field"><legend>사진 한 장</legend><label class="mc-upload" id="mc-drop" for="mc-file"><span class="mc-upload-icon">' + icon('upload') + '</span><span><strong id="mc-upload-title">내 사진 고르기</strong><small>또는 여기에 끌어다 놓기</small></span><input id="mc-file" type="file" accept="image/jpeg,image/png,image/webp,image/avif"/></label>',
  '<div class="mc-photo-meta"><span>JPG · PNG · WebP · AVIF / 최대 15MB</span><button type="button" id="mc-use-sample">샘플로 보기</button></div>',
  '<button type="button" class="button button-soft mc-edit-photo" id="mc-edit-photo">사진 편집</button><p class="mc-style-note">사진 위에서 직접 이동하고 확대·축소해요.</p></fieldset>',
  '<fieldset><legend>나를 소개해요</legend><div class="mc-theme-list" role="group" aria-label="능력치 테마">',
  ...CARD_THEMES.map((theme) => '<button type="button" data-theme="' + theme.id + '" aria-pressed="' + (theme.id === 'pet') + '">' + theme.title + '</button>'),
  '</div><label class="mc-text-label" for="mc-name">이름 또는 별명 <small>최대 12자</small></label><input class="mc-text-input" id="mc-name" type="text" autocomplete="off" value="두부" maxlength="48" placeholder="카드의 주인공은?" required/>',
  '<label class="mc-text-label" for="mc-skill">나만의 특수기 <small>선택 · 최대 30자</small></label><input class="mc-text-input" id="mc-skill" type="text" autocomplete="off" maxlength="120" placeholder="비워두면 재미있는 특수기를 뽑아드려요"/>',
  '<div id="mc-battle-fields"><label class="mc-text-label" for="mc-element">카드 속성 <small>스타 배틀 전용</small></label><select class="mc-text-input" id="mc-element"><option value="">뽑힌 속성 사용</option>',
  ...BATTLE_ELEMENTS.map((item) => '<option value="' + item.id + '">' + item.title + ' 속성</option>'),
  '</select><label class="mc-text-label" for="mc-story">캐릭터 소개 <small>선택 · 최대 70자</small></label><textarea class="mc-text-input mc-story" id="mc-story" maxlength="280" rows="3" placeholder="비워두면 캐릭터에 어울리는 소개를 넣어드려요"></textarea></div>',
  '<p class="mc-error" id="mc-error" role="alert"></p></fieldset>',
  '<button class="button button-primary mc-draw" type="submit" id="mc-draw">' + icon('shuffle') + '<span>나를 카드로 뽑아!</span></button>',
  '<p class="mc-draw-hint">뽑을 때마다 등급과 능력치가 달라져요.</p>',
  '</form><p class="mc-local-note">사진은 이 기기에서만 편집해요. 공유는 직접 선택할 때만.</p>',
  '<details class="mc-probabilities"><summary>카드 등급 안내</summary><p>R 55% · SR 33% · SSR 12%. 스타 배틀의 별은 R 3개, SR 4개, SSR 5개예요. 등급과 능력치는 사진 분석 없이 무작위로 정해지는 재미용 결과예요. 횟수 제한 없이 다시 뽑을 수 있어요.</p></details></section>',
  '</div><aside class="mc-ad" aria-label="광고 영역"><span>ADVERTISEMENT</span><div class="mc-ad-slot">광고 영역</div></aside>',
  relatedToolsMarkup('my-card'), '</main><footer class="legal-footer"><a href="/privacy/">개인정보처리방침</a><a href="/terms/">이용약관</a><span>© 2026 오늘툴</span></footer>',
  '<div id="mc-toast" class="mc-toast" role="status" aria-live="polite"></div></div>',
].join('');

function element<T extends HTMLElement>(id: string) { return document.getElementById(id) as T; }
const canvas = element<HTMLCanvasElement>('mc-card');
const context = canvas.getContext('2d');
if (!context) throw new Error('이 브라우저에서는 카드 이미지를 만들 수 없어요.');
const ctx = context;
const form = element<HTMLFormElement>('mc-form');
const stage = element<HTMLDivElement>('mc-stage');
const nameInput = element<HTMLInputElement>('mc-name');
const skillInput = element<HTMLInputElement>('mc-skill');
const saveButton = element<HTMLButtonElement>('mc-save');
const shareButton = element<HTMLButtonElement>('mc-share');
const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
const storyInput = element<HTMLTextAreaElement>('mc-story');
const openPhotoEditor = createPhotoEditor();
let identity: CardIdentity = { name: '두부', theme: 'pet', skill: '' };
let style: CardStyle = 'battle';
let result = makeCardResult(20260906, identity.theme);
let crop: PhotoCrop = { ...DEFAULT_CROP };
let photo: HTMLCanvasElement | HTMLImageElement | null = null;
let photoWidth = 0; let photoHeight = 0;
let sample = true; let busy = false; let loadingPhoto = false; let saving = false;
let photoRequest = 0; let drawFrame = 0; let revealTimer = 0; let toastTimer = 0;

function drawing(): CardDrawing { return { style, identity, result, photo, photoWidth, photoHeight, crop }; }
function track(event: string) { window.gtag?.('event', event, { tool: 'my-card', card_style: style, card_theme: identity.theme, sample_photo: sample }); }
function error(message: string) { element('mc-error').textContent = message; }
function toast(message: string) {
  const notice = element('mc-toast'); notice.textContent = message; notice.classList.add('visible');
  clearTimeout(toastTimer); toastTimer = window.setTimeout(() => notice.classList.remove('visible'), 3200);
}
function updateButtons() {
  form.querySelectorAll<HTMLInputElement | HTMLButtonElement | HTMLSelectElement | HTMLTextAreaElement>('input, button, select, textarea').forEach((button) => { button.disabled = busy || loadingPhoto || saving; });
  element<HTMLButtonElement>('mc-edit-photo').disabled = busy || loadingPhoto || saving || !photo;
  saveButton.disabled = busy || loadingPhoto || !photo || saving;
  shareButton.disabled = busy || loadingPhoto || !photo || saving;
  stage.setAttribute('aria-busy', String(busy || loadingPhoto));
}
function paint() {
  drawFrame = 0;
  drawCard(ctx, drawing());
  document.querySelectorAll<HTMLCanvasElement>('[data-thumb]').forEach((thumb) => {
    const thumbContext = thumb.getContext('2d');
    if (!thumbContext) return;
    thumbContext.save(); thumbContext.scale(thumb.width / CARD_WIDTH, thumb.height / CARD_HEIGHT);
    drawCard(thumbContext, { ...drawing(), style: thumb.dataset.thumb as CardStyle }); thumbContext.restore();
  });
  canvas.setAttribute('aria-label', identity.name + '의 ' + result.rarity + ' 캐릭터 카드');
  element('mc-summary').textContent = identity.name + ', ' + result.title + ', ' + result.rarity + '. ' + result.labels.map((label, index) => label + ' ' + result.stats[index]).join(', ') + '. 특수기: ' + (identity.skill || result.defaultSkill);
  if (style === 'battle') {
    const b = result.battle;
    element('mc-summary').textContent = identity.name + ', ' + result.title + ', ' + result.rarity + ', 별 ' + b.stars + '개. ' + BATTLE_ELEMENTS.find((item) => item.id === (identity.element || b.element))!.title + ' 속성. HP ' + b.hp + ', 레벨 ' + b.level + ', 공격력 ' + b.attack + ', 방어력 ' + b.defense + '. 특성 ' + b.passive.name + ': ' + (identity.skill || b.passive.description) + '. 필살기 ' + b.move.name + ': ' + b.move.description + ', 위력 ' + b.move.power + '. 약점 ' + b.weakness + ', 회복 ' + b.resistance + '. ' + (identity.story || b.story);
  }
  element('mc-battle-fields').hidden = style !== 'battle';
  element('mc-edition').textContent = CARD_STYLES.find((item) => item.id === style)!.title;
  element('mc-style-note').textContent = CARD_STYLES.find((item) => item.id === style)!.subtitle;
  element('mc-sample-tag').textContent = sample ? '샘플 사진' : '내 사진';
  stage.dataset.style = style;
  updateButtons();
}
function queuePaint() { if (!drawFrame) drawFrame = requestAnimationFrame(paint); }
function syncText() { identity = { ...identity, name: trimCardText(nameInput.value, 12), skill: trimCardText(skillInput.value, 30), story: trimCardText(storyInput.value, 70) }; queuePaint(); }
nameInput.addEventListener('input', () => { error(''); syncText(); });
skillInput.addEventListener('input', syncText);
storyInput.addEventListener('input', syncText);
storyInput.addEventListener('blur', () => { storyInput.value = trimCardText(storyInput.value, 70); });
element<HTMLSelectElement>('mc-element').addEventListener('change', (event) => {
  identity.element = (event.target as HTMLSelectElement).value as BattleElement || undefined;
  queuePaint();
});
nameInput.addEventListener('blur', () => { nameInput.value = trimCardText(nameInput.value, 12); });
skillInput.addEventListener('blur', () => { skillInput.value = trimCardText(skillInput.value, 30); });
document.querySelectorAll<HTMLButtonElement>('[data-style]').forEach((button) => button.addEventListener('click', () => {
  style = button.dataset.style as CardStyle;
  document.querySelectorAll('button[data-style]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
  paint(); track('card_style_selected');
}));
document.querySelectorAll<HTMLButtonElement>('[data-theme]').forEach((button) => button.addEventListener('click', () => {
  identity.theme = button.dataset.theme as CardTheme;
  result = makeCardResult(result.seed, identity.theme);
  document.querySelectorAll('[data-theme]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
  paint();
}));
element('mc-edit-photo').addEventListener('click', () => {
  if (!photo || busy || loadingPhoto || saving) return;
  openPhotoEditor({ photo, width: photoWidth, height: photoHeight, style, crop,
    apply: (edited) => { crop = edited; paint(); },
  });
});

async function loadPhoto(file?: File) {
  if (busy || saving) return;
  const validation = file ? photoValidation(file) : null;
  if (validation) { error(validation); return; }
  const request = ++photoRequest;
  loadingPhoto = true; error(''); updateButtons();
  const url = file ? URL.createObjectURL(file) : SAMPLE_PHOTO_URL;
  try {
    const image = new Image(); image.src = url; await image.decode();
    if (request !== photoRequest) return;
    if (!image.naturalWidth || image.naturalWidth * image.naturalHeight > 50_000_000) throw new Error('image-size');
    const scaled = document.createElement('canvas');
    const scale = Math.min(1, 1800 / Math.max(image.naturalWidth, image.naturalHeight));
    scaled.width = Math.round(image.naturalWidth * scale); scaled.height = Math.round(image.naturalHeight * scale);
    const scaledContext = scaled.getContext('2d');
    if (!scaledContext) throw new Error('canvas');
    scaledContext.drawImage(image, 0, 0, scaled.width, scaled.height);
    photo = scaled; photoWidth = scaled.width; photoHeight = scaled.height; sample = !file;
    crop = { ...DEFAULT_CROP };
    element('mc-upload-title').textContent = file ? '사진 바꾸기' : '내 사진 고르기';
    element('mc-preview-state').textContent = file ? '사진 위치와 이름을 맞춰보세요' : '사진을 넣어 나만의 카드로';
    if (file) track('card_photo_selected');
  } catch {
    if (request === photoRequest) error(file ? '이 사진을 열 수 없어요. 다른 JPG 또는 PNG 사진으로 다시 시도해 주세요.' : '샘플 사진을 불러오지 못했어요. 내 사진을 골라서 시작할 수 있어요.');
  } finally {
    if (file) URL.revokeObjectURL(url);
    if (request === photoRequest) { loadingPhoto = false; paint(); }
  }
}
element<HTMLInputElement>('mc-file').addEventListener('change', (event) => {
  const input = event.target as HTMLInputElement;
  const file = input.files?.[0]; input.value = '';
  if (file) void loadPhoto(file);
});
element('mc-use-sample').addEventListener('click', () => { void loadPhoto(); });
const drop = element('mc-drop');
drop.addEventListener('dragover', (event) => { event.preventDefault(); if (!busy && !loadingPhoto) drop.classList.add('is-over'); });
drop.addEventListener('dragleave', () => drop.classList.remove('is-over'));
drop.addEventListener('drop', (event) => {
  event.preventDefault(); drop.classList.remove('is-over');
  if (busy || loadingPhoto) return;
  const file = event.dataTransfer?.files[0]; if (file) void loadPhoto(file);
});

function finishReveal() {
  if (!busy) return;
  clearTimeout(revealTimer); busy = false;
  stage.classList.remove('is-opening'); stage.classList.add('is-revealed');
  element<HTMLButtonElement>('mc-skip').hidden = true;
  element('mc-preview-state').textContent = result.rarity + ' · ' + result.title;
  element('mc-draw').querySelector('span')!.textContent = '한 번 더 뽑기';
  paint(); canvas.focus({ preventScroll: true }); toast(result.rarity + '! ' + result.title + ' 등장'); track('card_draw_complete');
}
form.addEventListener('submit', (event) => {
  event.preventDefault();
  if (busy || loadingPhoto) return;
  identity.name = trimCardText(nameInput.value, 12); nameInput.value = identity.name;
  if (!identity.name) { error('카드에 넣을 이름이나 별명을 적어 주세요.'); nameInput.focus(); return; }
  if (!photo) { error('사진을 골라 주세요. 샘플 사진으로도 뽑아볼 수 있어요.'); return; }
  error(''); busy = true; updateButtons(); track('card_draw_start');
  const random = new Uint32Array(1); crypto.getRandomValues(random);
  result = makeCardResult(random[0], identity.theme);
  stage.classList.remove('is-revealed'); stage.classList.add('is-opening');
  element<HTMLButtonElement>('mc-skip').hidden = false;
  paint();
  if (matchMedia('(max-width: 767px)').matches) stage.scrollIntoView({ behavior: reducedMotion.matches ? 'instant' : 'smooth', block: 'center' });
  revealTimer = window.setTimeout(finishReveal, reducedMotion.matches ? 120 : 1700);
});
element('mc-skip').addEventListener('click', finishReveal);
document.addEventListener('visibilitychange', () => { if (document.hidden) finishReveal(); });

function cardBlob(): Promise<Blob> {
  paint();
  return new Promise((resolve, reject) => canvas.toBlob((blob) => blob ? resolve(blob) : reject(new Error('export')), 'image/png'));
}
function download(file: File) {
  const url = URL.createObjectURL(file); const anchor = document.createElement('a');
  anchor.href = url; anchor.download = file.name; document.body.append(anchor); anchor.click(); anchor.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 30_000);
}
async function save(share: boolean) {
  if (busy || loadingPhoto || saving || !photo) return;
  saving = true; updateButtons();
  try {
    await document.fonts.ready;
    const file = new File([await cardBlob()], '오늘툴-나의카드-' + result.serial + '.png', { type: 'image/png' });
    if (share && navigator.share && navigator.canShare?.({ files: [file] })) {
      try {
        await navigator.share({ files: [file], title: '나를 카드로 뽑아! | 오늘툴' });
        track('card_shared');
      } catch (cause) {
        if (cause instanceof DOMException && cause.name === 'AbortError') return;
        download(file); track('card_downloaded');
        toast('공유 메뉴를 열 수 없어 이미지로 저장했어요.');
      }
    } else {
      download(file); track('card_downloaded');
      toast(share ? '이미지를 저장했어요. 원하는 앱에 올려 주세요.' : '카드 이미지를 저장했어요.');
    }
  } catch (cause) {
    if (!(cause instanceof DOMException && cause.name === 'AbortError')) toast('저장하지 못했어요. 이미지 저장 버튼으로 다시 시도해 주세요.');
  } finally { saving = false; updateButtons(); }
}
saveButton.addEventListener('click', () => { void save(false); });
shareButton.addEventListener('click', () => { void save(true); });
paint();
void loadPhoto();
void Promise.all([document.fonts.load('800 40px "Noto Sans KR"'), document.fonts.load('700 40px "Lexend Deca"')]).then(() => paint()).catch(() => undefined);
